import dynamic from 'next/dynamic'
import { memo, useState } from 'react'
import { MdClose } from 'react-icons/md'
import ClickyLink from '../../components/navigation/ClickyLink'

type PropsType = {
  readonly videoUrl: string
}

function LearnPlayer(props: PropsType) {
  const { videoUrl } = props
  const [showPromptQuiz, setShowPromptQuiz] = useState(false)
  const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false })

  return (
    <div className="relative overflow-hidden">
      <ReactPlayer
        className="aspect-video"
        controls
        onEnded={() => setShowPromptQuiz(true)}
        width="100%"
        height="100%"
        url={videoUrl}
      />

      {showPromptQuiz && (
        <div className="absolute left-0 top-0 flex size-full items-center justify-center bg-grey/95">
          <div
            // TODO: Update to flex-y-sm when merged
            className="relative flex size-full flex-col items-center justify-center gap-2 text-center text-white"
          >
            <span>
              <span className="hidden sm:block">
                Click the Start Quiz button to the right
              </span>
              <span className="block sm:hidden">
                Click the "Take The Quiz" link below
              </span>{' '}
              to test your knowledge.
            </span>
            <ClickyLink
              as="text"
              onClick={() => setShowPromptQuiz(false)}
              className="underline"
            >
              Close
            </ClickyLink>
            <ClickyLink
              as="icon"
              icon={MdClose}
              className="absolute right-4 top-4 underline"
              onClick={() => setShowPromptQuiz(false)}
            >
              Close
            </ClickyLink>
          </div>
        </div>
      )}
    </div>
  )
}

export default memo(LearnPlayer)
